/**
 * Extending Leaflet to allow rotation images
 *
 * Need to do this oldschool Javascript style to extend the Leaflet ImageOverlay.
 */
export default function leafletRotatableImagePlugin(L: any) {
    // todo: fix
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - outside Leaflet typing
    L.RotatableImage = L.ImageOverlay.extend({
        options: { rotation: 0 },
        _animateZoom: function (event: L.LeafletMouseEvent) {
            // todo: fix
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            L.ImageOverlay.prototype._animateZoom.call(this, event);
            const img = this._image;
            img.style[L.DomUtil.TRANSFORM] += ' rotate(' + this.options.rotation + 'deg)';
        },
        _reset: function () {
            // todo: fix
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            L.ImageOverlay.prototype._reset.call(this);
            const img = this._image;
            img.style[L.DomUtil.TRANSFORM] += ' rotate(' + this.options.rotation + 'deg)';
        },
    });

    // todo: fix
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - outside Leaflet typing
    L.rotatableImage = (url: string, bounds: L.LatLngBounds, options: L.ImageOverlayOptions & { rotation: number }) => {
        // todo: fix
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return new L.RotatableImage(url, bounds, options);
    };
}
